import { EntityHoliday } from "../../entity/EntityHoliday";

export class DtoHolidaysPutRes extends EntityHoliday {}
